import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["variant", "children"];
import { Tag } from './Tag';
import { jsxs as _jsxs } from "react/jsx-runtime";
const NEWS_VARIANT = {
  emoji: '📰',
  use: 'oz'
};
const JOB_VARIANT = {
  emoji: '💼',
  use: 'oz'
};
export const SIGNAL_TAG_VARIANT = {
  COMPANY_RAISED_FUNDING: NEWS_VARIANT,
  CONTACT_JOB_ENDED: JOB_VARIANT,
  CONTACT_JOB_STARTED: JOB_VARIANT,
  EMAIL_BOUNCE_DETECTED: {
    emoji: '🚫',
    use: 'norman'
  },
  VISITOR_INTENT_UPDATE: {
    emoji: '🌐',
    use: 'marigold'
  },
  RESEARCH_INTENT_LEVEL_CHANGE: {
    emoji: '🔎',
    use: 'thunderdome'
  },
  TECHNOLOGY_INVESTMENT: NEWS_VARIANT,
  EXECUTIVE_HIRING: NEWS_VARIANT,
  GEOGRAPHIC_EXPANSION: NEWS_VARIANT,
  LEADERSHIP_CONTENT: NEWS_VARIANT
};
export const SignalTag = _ref => {
  let {
      variant,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const use = SIGNAL_TAG_VARIANT[variant].use;
  const emoji = SIGNAL_TAG_VARIANT[variant].emoji;
  return /*#__PURE__*/_jsxs(Tag, Object.assign({}, rest, {
    variant: use,
    children: [emoji, " ", children]
  }));
};